import CusToast from '@/components/common/customize-toast/index.vue';
import { h, render } from 'vue';
const createToast = (text, callback) => {
    const d = document.createElement('div');
    const vnode = h(CusToast, {
        text,
        clickFun: () => {
            callback();
            document.body.removeChild(document.body.lastChild);
        }
    });
    render(vnode, d);
    document.body.appendChild(d.firstElementChild);
};
const formatNumber = (num) => Number(num).toLocaleString();
export default null;
export { createToast, formatNumber };
